const path = require('path')
// const TerserPlugin = require('terser-webpack-plugin')
/* eslint-disable */
module.exports = {
  devServer: {
    disableHostCheck: true,
    // compress: false,
    // overlay: {
    //   warnings: true,
    //   errors: true
    // }
  },

  configureWebpack: {
    resolve: {
      alias: {
        namisconfig: process.env.NODE_ENV === 'production' ? path.resolve(__dirname, 'src/config/namis-prod.js') : path.resolve(__dirname, 'src/config/namis-prod.js'),
        appconfig: process.env.NODE_ENV === 'production' ? path.resolve(__dirname, 'src/config/prod.js') : path.resolve(__dirname, 'src/config/dev.js'),
        NafComponents: path.resolve(__dirname, 'src/components'),
        src: path.resolve(__dirname, 'src/'),
        command: path.resolve(__dirname, 'src/plugins/Command'),
        'naf-acl': path.resolve(__dirname, 'src/modules/acl'),
        'utils': path.resolve(__dirname, 'src/plugins/Utils')
      }
    },
    plugins: [

    ],
    optimization: {
      minimizer: process.env.NODE_ENV === 'production' ? [
        // new TerserPlugin({
        //   sourceMap: true,
        //   terserOptions: {
        //     compress: {
        //       drop_console: true
        //     }
        //   }
        // })
      ] : []
    }
  },

  pwa: {
    themeColor: '#a8af60',
    workboxPluginMode: 'InjectManifest',
    workboxOptions: {
      swSrc: 'src/service-worker.js'
    }
  },

  pluginOptions: {
    quasar: {
      rtlSupport: true,
      treeShake: true
    }
  },
  transpileDependencies: [
    /[\\/]node_modules[\\/]quasar[\\/]/
  ]
}
